import { getSuperStoreInstance } from '../../rewrite/superstore/getSuperStoreInstance';
import { getSuperStoreValue } from '../../rewrite/superstore/getSuperStoreValue';
import { setSuperStoreValue } from '../../rewrite/superstore/setSuperStoreValue';
export const clientStorage = {
  getItem: async key => {
    const value = await getSuperStoreValue(key);
    return value ? String(value) : null;
  },
  setItem: async (key, value) => {
    await setSuperStoreValue(key, value);
  },
  removeItem: async key => {
    const idbStore = await getSuperStoreInstance();
    if (!idbStore) {
      return;
    }
    await idbStore.delete(key);
  }
};